module.exports = __webpack_public_path__ + "img/btninmodal-plus-m-big.8a39e251.svg";